import apiService from "./apiService";
import AppConstants from "../appConstants";

class OriginService {
    getAllOrigin(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ORIGIN, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getOriginDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ORIGIN}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerOrigin(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ORIGIN, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteOrigin(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_ORIGIN}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    syncOrigin(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ORIGIN_SYNC}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_ORIGIN_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new OriginService();
